export const libraryTypes = {
  ADD: 'library_add',
  CLEAR: 'library_clear',
  EDITING_NAME: 'library_editing_name',
  FIND_ONE: 'library_find_one',
  FIND_ITUNES: "library_find_itunes",
  LOAD: 'library_loading',
  LOAD_COMPLETE: 'library_loading_complete',
  LOADING_ERROR: 'library_loading_error',
  LOADING_SEARCH: 'library_loading_search',
  LOADING_SEARCH_ITUNES: 'library_loading_search_itunes',
  SEARCH: 'library_search',
  SEARCH_ITUNES: 'library_search_itunes',
  UPDATE: 'library_update',


};
